module.exports = "<div class=\"videogular-container\">\n    <videogular>\n        <vg-media vg-src=\"$ctrl.config.sources\" vg-native-controls=\"true\"></vg-media>\n    </videogular>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/video-player/video-player.component.html
// module id = 604
// module chunks = 0